<div *ngIf="userDeviceInfo === 'pc'" class="button-top {{ userDeviceInfo }}" (click)="scrollToTop()" [ngClass]="{ 'show-scrollTop': windowScrolled }">
  <button></button>
  <span [style.display]="userDeviceInfo === 'pc' ? 'inline' : 'none'">TOP</span>
</div>

<div *ngIf="userDeviceInfo === 'mobile'" class="arrow-up-wrap" (click)="scrollToTop()" [ngClass]="{ 'show-scrollTop': windowScrolled }">
  <svg-icon  class="arrow-up-fab-button" src="/assets/images/arrow-up-outline.svg" alt="" srcset="" />
</div>
